import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { BASE_URL, STATIC_BASE_URL} from "../../config/baseUrl";
import "./TeamPage.css";

export default function TeamPage() {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // fallback image from public folder
  const fallbackImage = `${process.env.PUBLIC_URL}/assets/img/team/team-1.jpg`;

  useEffect(() => {
    const fetchMember = async () => {
      try {
        const res = await fetch(`${BASE_URL}/Mentor/${id}`);
        if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
        const data = await res.json();
        setMember(data);
      } catch (err) {
        console.error("Error fetching member:", err);
        setError("Failed to load mentor details.");
      } finally {
        setLoading(false);
      }
    };

    fetchMember();
  }, [id]);

  // Helper to build image URL
  const getImageUrl = (profileImageUrl) => {
    if (!profileImageUrl) return fallbackImage;

    // Absolute URL stays as is
    if (profileImageUrl.startsWith("http")) return profileImageUrl;

    // Otherwise, prepend BASE_URL
    return `${STATIC_BASE_URL}/${profileImageUrl.replace(/\\/g, "/")}`;
  };

  // handle 1:1 session button click
  const handleSessionClick = () => {
    window.location.href = `/book-session/${id}`;
  };

  return (
    <>
      <Navbar />

      <section className="team-detail section">
        <div className="container">
          {loading ? (
            <p className="loading-text">Loading mentor details...</p>
          ) : error ? (
            <p className="error-text">{error}</p>
          ) : member ? (
            <div className="profile">
              <div className="profile-img">
                <img
                  src={getImageUrl(member.profileImageUrl)}
                  alt={member.mentorName || "Mentor"}
                  className="mentor-img"
                  onError={(e) => { e.target.src = fallbackImage; }}
                />
              </div>

              <div className="profile-info">
                <h2>{member.mentorName}</h2>
                <h5>{member.specialization || member.role}</h5>
                <p>{member.bio || "No bio available."}</p>

                {/* Optional social links
                <div className="social-links">
                  <a href={member.linkedin || "#"} target="_blank" rel="noreferrer">
                    <i className="bi bi-linkedin"></i>
                  </a>
                  <a href={member.twitter || "#"} target="_blank" rel="noreferrer">
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a href={member.facebook || "#"} target="_blank" rel="noreferrer">
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a href={member.instagram || "#"} target="_blank" rel="noreferrer">
                    <i className="bi bi-instagram"></i>
                  </a>
                </div>
                */}

                <button
                  className="btn btn-get-started mt-3"
                  onClick={handleSessionClick}
                >
                  Book 1:1 Session
                </button>
              </div>
            </div>
          ) : (
            <p className="error-text">Mentor not found.</p>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
}
